var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoPaiementTopnet(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 115,
    height: 22,
    viewBox: "0 0 115 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.0163 5.10577H19.8797C17.9895 2.04205 14.6018 0 10.737 0C4.80731 0 0 4.80731 0 10.737C0 15.6834 3.3456 19.8478 7.89654 21.094L12.2217 5.10577H17.0163Z",
    fill: "url(#paint0_linear_12068_120552)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4701 10.7372C21.4701 8.67222 20.886 6.74241 19.8758 5.10596H17.0123H12.2178L7.89258 21.0942C8.7969 21.3416 9.74969 21.4743 10.7331 21.4743C16.6628 21.4743 21.4701 16.667 21.4701 10.7372Z",
    fill: "url(#paint1_linear_12068_120552)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.913 5.16385C19.5061 4.49549 19.0291 3.87561 18.4909 3.31312C18.3569 3.28251 18.2179 3.26465 18.0751 3.26465H6.87245C5.85589 3.26465 5.0332 4.08861 5.0332 5.1039C5.0332 6.11919 5.85717 6.94315 6.87245 6.94315H9.6071L7.27551 15.5603C6.98087 16.6483 7.62499 17.7682 8.71171 18.0628C8.89027 18.1113 9.06884 18.1343 9.24613 18.1343C10.1454 18.1343 10.968 17.5361 11.2142 16.6266L13.8341 6.9457H18.0738C19.0712 6.94443 19.8824 6.15235 19.913 5.16385Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7344 20.8203C16.3036 20.8203 20.8184 16.3056 20.8184 10.7363C20.8184 5.1671 16.3036 0.652344 10.7344 0.652344C5.16515 0.652344 0.650391 5.1671 0.650391 10.7363C0.650391 16.3056 5.16515 20.8203 10.7344 20.8203Z",
    fill: "url(#paint2_radial_12068_120552)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M67.9328 5.0666C66.9698 3.81025 65.5081 3.0896 63.9252 3.0896H60.1395C58.8641 3.0896 57.7416 3.95055 57.4113 5.18267L54.581 15.7309C54.2927 16.8062 54.9305 17.9133 56.007 18.2016C56.1817 18.2488 56.3577 18.2704 56.5312 18.2704C57.4215 18.2704 58.2365 17.6761 58.4776 16.7756L59.2391 13.9389H62.9507C65.6879 13.9389 68.0948 12.0933 68.8039 9.44917C69.2146 7.91987 68.897 6.32296 67.9328 5.0666ZM64.9073 8.40455C64.6701 9.28846 63.8652 9.9058 62.9507 9.9058H60.3219L61.0681 7.12524H63.9265C64.3627 7.12524 64.6191 7.37396 64.7326 7.52319C64.8461 7.67115 65.0208 7.98236 64.9073 8.40455Z",
    fill: "#292D6C"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M39.4868 5.10735C39.4868 4.08823 38.6602 3.26172 37.6411 3.26172H26.3046C25.2855 3.26172 24.459 4.08823 24.459 5.10735C24.459 6.12646 25.2855 6.95298 26.3046 6.95298H29.1043L26.7498 15.7321C26.4615 16.8087 27.0992 17.9145 28.1758 18.2028C28.3505 18.25 28.5265 18.2716 28.7 18.2716C29.5903 18.2716 30.4053 17.6773 30.6464 16.7768L33.2815 6.95298H37.6411C38.6615 6.95298 39.4868 6.12646 39.4868 5.10735Z",
    fill: "#292D6C"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M113.002 3.26172H101.666C100.647 3.26172 99.8203 4.08823 99.8203 5.10735C99.8203 6.12646 100.647 6.95298 101.666 6.95298H104.466L102.111 15.7321C101.823 16.8087 102.461 17.9145 103.537 18.2028C103.712 18.25 103.888 18.2716 104.061 18.2716C104.952 18.2716 105.767 17.6773 106.008 16.7768L108.643 6.95298H113.002C114.022 6.95298 114.848 6.12646 114.848 5.10735C114.848 4.08823 114.022 3.26172 113.002 3.26172Z",
    fill: "#292D6C"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M97.1317 3.26172H89.1816C88.8474 3.26172 88.5337 3.35228 88.2633 3.50789C87.7594 3.75278 87.3589 4.20558 87.1995 4.78975L84.2085 15.7219C84.0478 16.3099 84.1651 16.9069 84.4789 17.3763C84.7939 17.9426 85.3972 18.3252 86.0911 18.3252H94.3767C95.3958 18.3252 96.2223 17.4987 96.2223 16.4796C96.2223 15.4605 95.3958 14.634 94.3767 14.634H88.6867L89.2339 12.6327H94.9455C95.9647 12.6327 96.7912 11.8062 96.7912 10.7871C96.7912 9.76798 95.9647 8.94146 94.9455 8.94146H90.2428L90.7875 6.9517H97.1292C98.1483 6.9517 98.9748 6.12519 98.9748 5.10607C98.9748 4.08696 98.1508 3.26172 97.1317 3.26172Z",
    fill: "#292D6C"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M52.1726 4.56614C50.6509 3.15418 48.6102 2.51133 46.4278 2.7575C44.3615 2.98964 42.4036 4.00238 40.9139 5.60821C39.4241 7.21405 38.5606 9.24335 38.4841 11.3211C38.4037 13.5162 39.1971 15.5022 40.7187 16.9141C42.0605 18.1577 43.7875 18.7649 45.5719 18.7649C47.8449 18.7649 50.2083 17.7789 51.9787 15.8721C55.1355 12.4678 55.2223 7.39645 52.1726 4.56614ZM48.8946 13.0124C47.3143 14.7165 44.9291 15.0838 43.5784 13.8313C42.9687 13.265 42.6511 12.4282 42.6868 11.4755C42.7263 10.404 43.1919 9.33646 43.9967 8.46913C44.8016 7.60052 45.8321 7.05717 46.8972 6.93727C47.0388 6.92196 47.1778 6.91304 47.3155 6.91304C48.0961 6.91304 48.7938 7.16813 49.313 7.64899C50.6624 8.90279 50.4749 11.3084 48.8946 13.0124Z",
    fill: "#292D6C"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M84.0414 3.1591C82.9649 2.87084 81.8591 3.50859 81.5708 4.5851L79.7137 11.5084L76.5377 4.63612C76.1041 3.69736 75.1551 3.0915 74.122 3.0915C72.9205 3.0915 71.8631 3.90271 71.5506 5.06341L68.6884 15.7316C68.4001 16.8081 69.0379 17.9139 70.1144 18.2022C71.1896 18.4905 72.2968 17.8527 72.585 16.7762L74.4664 9.76612L77.8311 17.0466C78.238 17.928 79.1283 18.4981 80.1002 18.4981C81.229 18.4981 82.2213 17.7366 82.5147 16.6461L85.47 5.631C85.7557 4.55321 85.1167 3.44736 84.0414 3.1591Z",
    fill: "#292D6C"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_12068_120552",
    x1: 7.57361,
    y1: -0.866769,
    x2: 12.6541,
    y2: 19.4328,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3618,
    stopColor: "#292D6C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4537,
    stopColor: "#2B3671"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.605,
    stopColor: "#2F4F7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7971,
    stopColor: "#377891"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#40AAAA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_12068_120552",
    x1: 14.8083,
    y1: 1.94619,
    x2: 14.6224,
    y2: 22.4478,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2791,
    stopColor: "#EA442A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5883,
    stopColor: "#F59326"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8077,
    stopColor: "#FCC424"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9158,
    stopColor: "#FFD723"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_12068_120552",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(12.1743 -12.0578 7.2806 7.35257 2.48456 1.64967)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2791,
    stopColor: "white",
    stopOpacity: 0.35
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9158,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoPaiementTopnet);
export default __webpack_public_path__ + "static/media/logoPaiementTopnet.0f86b8dce076ebb9dce2be45d70a6bdd.svg";
export { ForwardRef as ReactComponent };